import React from 'react'
import { TextStyle, View, ViewStyle } from 'react-native'
import { Button } from '../button'
import { color } from '../../theme'
import { Text } from '../text'

interface SectionHeaderProps {
  headerText?: string
  headerTx?: string
  rightAction?: (() => void) | null
  rightActionTx?: string
  rightActionText?: string
  style?: ViewStyle
}

export const SectionHeader = (props: SectionHeaderProps) => {
  const { style, headerTx, headerText, rightAction, rightActionTx, rightActionText } = props
  return (
    <View style={{ ...SECTION_HEADER, ...style }}>
      <Text variant="titleEmphasized" text={headerText} tx={headerTx} />
      {rightAction && (
        <Button
          onPress={rightAction}
          variant="text"
          tx={rightActionTx ?? 'Common.seeAll'}
          text={rightActionText}
          textStyle={SECTION_ACTION}
        />
      )}
    </View>
  )
}

const SECTION_HEADER: ViewStyle = {
  backgroundColor: color.white,
  paddingBottom: 16,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}
const SECTION_ACTION: TextStyle = { color: '#00000050' }
